import React from "react";
import { FormValidationState } from "./models";

interface FormValidateProps {
  errors: FormValidationState;
  children: React.ReactNode;
}

export const FormValidate = ({ errors, children }: FormValidateProps) => {
  const renderChildren = (children: React.ReactNode): React.ReactNode => {
    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) {
        return child;
      }

      if (child.props.name) {
        const fieldName = child.props.name;
        const fieldNameValid = `${fieldName}`;
        const errorMessage = errors[fieldNameValid];
        return (
          <div>
            {React.cloneElement(child, child.props)}
            {errorMessage && (
              <div
                key={`error-${fieldName}`}
                style={{ color: errorMessage === null ? "" : "red" }}
              >
                {errorMessage}
              </div>
            )}
          </div>
        );
      }

      if (child.props.children) {
        return React.cloneElement(child, {
          ...child.props,
          children: renderChildren(child.props.children),
        });
      }

      return child;
    });
  };

  return <div>{renderChildren(children)}</div>;
};
